import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function getClientTemplate (params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(mock.getClientTemplate)
      }, 500)
    })
  } else {
    const req = {
      url: '/api/plantillas/getplantillacliente',
      method: 'GET',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      params
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { getClientTemplate }
